import { List, Moon, SignOut, Sun, UserCircle, X } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { track } from "../lib/analytics";
import { BrandMark } from "./BrandMark";

interface HeaderProps { onAuth(): void }

function navigate(event: React.MouseEvent<HTMLAnchorElement>, path: string) {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
  const hash = path.includes("#") ? path.split("#")[1] : "";
  if (hash) document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
  else window.scrollTo({ top: 0, behavior: "smooth" });
}

export function AppLink({ to, children, className, onClick }: { to: string; children: React.ReactNode; className?: string; onClick?: () => void }) {
  return <a className={className} href={to} onClick={(event) => { onClick?.(); navigate(event, to); }}>{children}</a>;
}

export function Header({ onAuth }: HeaderProps) {
  const { user, loading, logout } = useAuth();
  const [menu, setMenu] = useState(false);
  const [dark, setDark] = useState(() => document.documentElement.dataset.theme === "dark");

  useEffect(() => {
    document.documentElement.dataset.theme = dark ? "dark" : "light";
    localStorage.setItem("kbg-theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <header className="site-header">
      <AppLink to="/" className="wordmark" aria-label="KleanBG home"><BrandMark /><span>KleanBG</span></AppLink>
      <nav className={menu ? "nav-links open" : "nav-links"} aria-label="Main navigation">
        <AppLink to="/#features">Features</AppLink>
        <AppLink to="/pricing">Pricing</AppLink>
        <AppLink to="/privacy">Privacy</AppLink>
        {loading ? <span className="nav-session-loading" aria-label="Checking account">Checking account</span> : user ? (
          <>
            <AppLink to="/account" className="nav-account"><UserCircle size={20} weight="bold" /> Account</AppLink>
            <button className="nav-account" onClick={() => { track("logout"); void logout(); }}><SignOut size={20} weight="bold" /> Sign out</button>
          </>
        ) : (
          <button className="nav-account" onClick={onAuth}><UserCircle size={20} weight="bold" /> Sign in</button>
        )}
      </nav>
      <div className="header-actions">
        <button className="icon-button" onClick={() => setDark((value) => !value)} aria-label={dark ? "Use light theme" : "Use dark theme"}>
          {dark ? <Sun size={19} weight="bold" /> : <Moon size={19} weight="bold" />}
        </button>
        <button className="menu-button" onClick={() => setMenu((value) => !value)} aria-label="Toggle navigation" aria-expanded={menu}>
          {menu ? <X size={22} /> : <List size={22} />}
        </button>
      </div>
    </header>
  );
}
